"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var NextStatus = function (_a) {
    var nextStatus = _a.nextStatus, nextLevel = _a.nextLevel, pointNeeded = _a.pointNeeded, image = _a.image;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.imageWrapper },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: image, alt: nextStatus })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.greyText },
                t('nextStatus'),
                ":"),
            nextStatus && (react_1.default.createElement("div", { className: styles_module_scss_1.default.status },
                nextStatus,
                " (",
                t('level') + ' ' + nextLevel,
                ")")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.greyText },
                t('pointsNeeded'),
                ":"),
            pointNeeded ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsNeeded }, pointNeeded)) : null)));
};
exports.default = NextStatus;
